<template>
  <div class="form-builder_lookupDefault">
    <b-form-group label="Default value:">
      <multiselect
        v-model="selectedLookUp"
        :options="lookups"
        track-by="value"
        label="text"
        :searchable="true"
        :allow-empty="false"
        selectLabel
        selectedLabel
        tagPlaceholder
        placeholder
        deselectLabel
        openDirection="bottom"
        @select="save"
        :disabled="control.readonly"
      />
      <b-form-input placeholder="Enter expression" v-model="control.defaultValue" />
    </b-form-group>
    <b-form-group label="Is able to add value:">
      <b-form-checkbox v-model="control.ableToAddLookUpVal">
        <span
          v-back-to-default="[
            $parent.inheritedControlInfo,
            control,
            'ableToAddLookUpVal',
            $parent.backToDefault
          ]"
        >{{ control.ableToAddLookUpVal ? "yes": "no" }}</span>
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find, debounce } from 'lodash'

export default {
  props: ['control'],
  data() {
    return {
      rowKey: null,
      cellKey: null,
      cellVal: null,
      options: null,
      lookUpTable: null,
      selectedLookUp: { value: null, text: 'BLANK' },
      debounced: null
    }
  },
  watch: {
    control: {
      deep: true,
      handler() {
        this.setLookUpVal()
      },
    },
    lookups() {
      this.setLookUpVal()
    },
  },
  computed: {
    ...mapState(['dataGrid_options']),
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = [{ value: null, text: 'BLANK' }]
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    setLookUpVal() {
      if (this.debounced) {
        this.debounced()
      } else {
        this.debounced = debounce(() => {
          if (this.control.defaultValue)
            this.selectedLookUp = find(this.lookups, {
              value: this.control.defaultValue,
            })
          else this.selectedLookUp = { value: null, text: 'BLANK' }
        }, 500)
      }
    },
    save(item) {
      this.control.defaultValue = item.value || ''
    },
    backToDefault(prop, value) {
      this.$parent.backToDefault(prop, value)

      this.setLookUpVal()
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[formBuilderInst.gridId]
      this.lookUpTable = this.dataGrid_options[this.gridId].meta[
        this.cellKey
      ].lookUpTable

      this.setLookUpVal()
    })
  },
}
</script>

<style>
.form-builder_lookupDefault + div > div:first-child {
  display: none;
}
</style>
